export class PurchaseOrderItem {
    public readonly id!: string;
    public readonly poId!: string;
    public readonly status!: string;
    public readonly productId!: string;
    public readonly productDisplayName!: string;
    public readonly manufacturer!: string;
    public readonly mpn!: string;
    public readonly quantity!: number;
    public readonly received!: number;
    public readonly billed!: number;
    public readonly expectedReceiptDate!: Date;
    public readonly etaPort!: Date;
    public readonly masterBillOfLading!: string;
    public readonly containerId!: string;
    public readonly consignmentLocationId!: string;
    public readonly consignmentLocationName!: string;
    public readonly inConsignmentDate!: Date;
    public readonly legalEntity!: string;
    public readonly euroPerWatt!: number;
    public readonly rate!: number;
    public readonly amount!: number;
    public readonly linkedSalesOrder!: string;
    public readonly purchaseOrderSubStatus!: string;
    public readonly containerQuantity!: number;
    public readonly palletQuantity!: number;
}
